import { Component, Input } from '@angular/core';
import { TrafficLightComponentModel, TrafficLightColorComponentModel } from './traffic-lights.interfaces';

@Component({
  standalone: false,
    selector: 'faro-traffic-light-list',
    templateUrl: './traffic-light-list.component.html',
    styleUrls: ['./traffic-light-list.component.scss'],
})
export class TrafficLightListComponent {
    @Input()
    trafficLights?: TrafficLightComponentModel[];

    getColorForTrafficLight(trafficLight?: TrafficLightComponentModel): string {
        switch (trafficLight?.color) {
            case TrafficLightColorComponentModel.None:
                return 'background-none';
            case TrafficLightColorComponentModel.Green:
                return 'background-green';
            case TrafficLightColorComponentModel.Yellow:
                return 'background-yellow';
            case TrafficLightColorComponentModel.Red:
                return 'background-red';
            default:
                return '';
        }
    }
}
